import { useContext, useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { AcquiringOperationsDto } from "../../../../dtos/documents/AcquiringOperations/AcquiringOperationsDto";
import { FormProvider, useForm } from "react-hook-form";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFLookupVendor } from "../../../Shared/NewForms/NFLookupVendor";
import { NFLookupBankAcquirer } from "../../../Shared/NewForms/NFLookupBankAcquirer";
import { AcquiringOperationsModel } from "../../../../models/Documents/AcquiringOperations/AcquiringOperationsModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import * as XLSX from "xlsx";
import { NFLookupCashflowItem } from "../../../Shared/NewForms/NFLookupCashflowItem";
import { AcquiringOperationType } from "../../../../dtos/documents/AcquiringOperations/CreateAcquiringOperationsDto";
import { NFLookupCustomer } from "../../../Shared/NewForms/NFLookupCustomer";
import { NFLookupPosTerminal } from "../../../Shared/NewForms/NFLookupPosTerminal";
import { NFLookupCashRegister } from "../../../Shared/NewForms/NFLookupCashRegister";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import AcquiringOperationsDetailSkeleton from "./AcquiringOperationsDetailSkeleton";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel } from "../../../../helpers/SaveObjectToExcel";
import { saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import { AcquiringOperationsDetailFooter } from "./AcquiringOperationsDetailFooter";

interface IProps {
  model: AcquiringOperationsDto | null;
  modelUpdatedEvent: (newModel: AcquiringOperationsDto) => void;
}

export const AcquiringOperationsDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Acquiring Operations");
  const AcquiringOperaionTypeList = [
    {
      id: AcquiringOperationType.pay,
      name: "pay"
    },
    {
      id: AcquiringOperationType.return,
      name: "return"
    }
  ];

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<AcquiringOperationsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const watchProducts = watch("documentNumber");

  useEffect(() => {
    console.log(model);
    register("documentNumber");
    if (model) {
      setValue("id", model.id);
      setValue("baseDocumentAtId", model.baseDocumentAtId);
      setValue("documentDate", model.documentDate);
      setValue("documentNumber", model.documentNumber);
      setValue("companyId", model.companyId);
      setValue("cashFlowItemId", model.cashFlowItemId);
      setValue("operationType", model.operationType);
      setValue("vatAmount", model.vatAmount);
      setValue("comment", model.comment);
      setValue("vatType", model.vatType);
      setValue("createdDate", model.createdDate);
      setValue("amount", model.amount);
      setValue("taxation", model.taxation);
      setValue("vendorCustomerId", model.vendorCustomerId);
      setValue("bankAcquirerId", model.bankAcquirerId);
      setValue("posTerminalId", model.posTerminalId);
      setValue("cashRegisterRetailId", model.cashRegisterRetailId);
      setValue("accountId", model.accountId);
      setValue("settlementAccountId", model.settlementAccountId);
    }
  }, [model]);
  useEffect(() => {
    console.log(watchProducts);
  }, [watchProducts]);

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: AcquiringOperationsModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };
  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };
  if (!model) {
    return (
      <>
        <AcquiringOperationsDetailSkeleton />
      </>
    );
  }
  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.AcquiringOperations.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Additional"} />
        {/* <NFTab title={"Products"} /> */}
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        />

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Document #"} fieldName={"documentNumber"} disabled />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Document Date"} fieldName={"documentDate"} required={true} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupInput title={"Products"} fieldName={"operationType"} items={AcquiringOperaionTypeList} />
            </Col>
            <Col sm={6}>
              <NFLookupCustomer title="Customer" fieldName="vendorCustomerId" />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupPosTerminal title="PosTerminal" fieldName="posTerminalId" />
            </Col>
            <Col sm={6}>
              <NFLookupCashRegister title="Cash Register Retail" fieldName="cashRegisterRetailId" />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFIntInput title="amount" fieldName="amount" />
            </Col>
            <Col sm={6}>
              <NFLookupAccount title="Account" fieldName="accountId" />
            </Col>
            <Col sm={6}>{/* <Nflookupsettlemen */}</Col>
          </Row>
          {/*  */}
          <Row>
            <Col sm={6}>
              <NFLookupBankAcquirer fieldName={"bankAcquirerId"} title={"Bank Acquirer ID"} />
            </Col>
            <Col sm={6}>
              <NFLookupCashflowItem fieldName={"cashFlowItemId"} title={"CashFLow"} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupVendor fieldName={"vendorCustomerId"} title={"Vendor Customer"} required={true} />
            </Col>
            <Col sm={6}>
              <NFLookupCompany fieldName={"companyId"} title={"Company"} required={true} />
            </Col>
          </Row>
        </NFTabContainer>

        {/* <NFTabContainer index={1} currentIndex={tabIndex}>
                    <NFormTable fieldArray={"postingOfGoodGoods"}>
                        <NFLookupProduct fieldName={"productId"} title={"Product"} required={true} width={300} />
                        <NFIntInput fieldName={"quantity"} title={"Quantity"} width={100} />
                        <NFIntInput fieldName={"price"} title={"Price"} width={100} />
                        <NFIntInput fieldName={"amount"} title={"Amount"} width={100} />
                        <NFPlainText fieldName={"productVendorCode"} title={"Product Vendor Code"} width={150} />
                    </NFormTable>
                </NFTabContainer> */}

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
            </Col>
          </Row>
        </NFTabContainer>
      </div>
      <AcquiringOperationsDetailFooter />
    </FormProvider>
  );
};
